export default defineNuxtPlugin(() => {
  const addedSchemas = new Set<string>();

  const eventSchemaMap = new WeakMap();

  // Clear schemas when navigating to a new page
  const router = useRouter();
  router.beforeEach(() => {
    // Remove all script tags created by this plugin
    if (import.meta.client) {
      addedSchemas.forEach((id) => {
        const scriptTag = document.getElementById(`schema-${id}`);
        if (scriptTag) scriptTag.remove();
      });
    }
    addedSchemas.clear();
    return true;
  });

  return {
    provide: {
      addEventSchema: (event: any, lang: 'no' | 'en') => {
        if (!event || !event.content) {
          return null;
        }

        // Use cached schema ID if we've seen this event before
        let schemaId = eventSchemaMap.get(event);
        if (!schemaId) {
          schemaId = `event-${event.uuid || event.id || Math.random().toString(36).substring(2, 10)}`;
          eventSchemaMap.set(event, schemaId);
        }

        if (addedSchemas.has(schemaId)) {
          return null;
        }

        try {
          const { generateEventSchema } = useEventSchema();
          const schema = generateEventSchema(event, lang);

          if (schema) {
            addedSchemas.add(schemaId);

            useHead({
              script: [
                {
                  id: `schema-${schemaId}`,
                  type: 'application/ld+json',
                  innerHTML: JSON.stringify(schema),
                  key: `schema-${schemaId}`,
                },
              ],
            });

            return schema;
          }
        } catch (error) {
          console.error(`Failed to generate schema for event ${schemaId}`, error);
        }

        return null;
      },
    },
  };
});
